// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"31d7b9d0","306":"672b059b","457":"7b7af1bb","527":"2791d207","570":"7b432f5b","654":"c7afa399","787":"c36923ad","843":"7817b37c"}[chunkId] + ".chunk.js";
};